import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import App from "./App";
import "./index.css";
// GA
import config from './config';
import { createBrowserHistory } from 'history';
import ReactGA from 'react-ga4';

export default createBrowserHistory({});

ReactGA.initialize(config.ga_analytics);

const hist = createBrowserHistory();
hist.listen(location => {
  ReactGA.set({ page: location.pathname })
  ReactGA.send({ hitType: "pageview", page: location.pathname});
});

ReactDOM.render(
  <Router history={hist}>
    <App />
  </Router>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js